import React, { Suspense } from 'react';
import { Navigate, useLocation, useRoutes } from 'react-router-dom';
import FsLoader from '../common/fsLoader/fsLoaderComponent';
import Header from '../common/Header/HeaderComponent';
import { paths, privateRoutes, protectedRouteList, publicRoutes } from './routesConfig';
import { checkRoutePermission } from '../utils/featureUtils';
import { setStringInStorage } from '../services/storageService';
import { isAuthenticated } from '../services/authService';

const AppRoutes = () => useRoutes([...publicRoutes, privateRoutes]);

const Routes = () => {
  const currentLocation = useLocation();
  const key = Object.keys(protectedRouteList).filter(
    (key) => protectedRouteList[key].path === currentLocation.pathname,
  )[0];
  const hasRouteAccess = checkRoutePermission(protectedRouteList[key]);
  const isLoggedIn = isAuthenticated();
  let redirectUrl = false;

  if (
    !isLoggedIn &&
    ![paths.login, paths.forgotPassword, paths.resetPassword, '/'].includes(
      currentLocation.pathname,
    )
  ) {
    setStringInStorage('redirect_to', `${currentLocation.pathname}${currentLocation.search}`);
    redirectUrl = true;
  }

  return (
    <Suspense
      fallback={
        <>
          <FsLoader />
          <Header />
        </>
      }
    >
      {!isLoggedIn && redirectUrl && <Navigate to={paths.login} />}
      {!hasRouteAccess && isLoggedIn && <Navigate to={paths.accessDenied} />}
      <AppRoutes />
    </Suspense>
  );
};

export default Routes;
